import { useId, type ReactNode, type SelectHTMLAttributes } from 'react';
import { cx } from './cx';

export function Select({ label, className, id, children, small, ...rest }: SelectHTMLAttributes<HTMLSelectElement> & { label?: ReactNode; small?: boolean; children: ReactNode }) {
  const auto = useId();
  const fid = id ?? auto;
  return (
    <div className={className}>
      {label && <label htmlFor={fid} className="mb-1.5 block text-sm font-semibold">{label}</label>}
      <select id={fid} className={cx('w-full rounded-[10px] border border-line-strong bg-white px-2.5', small ? 'h-9 text-sm' : 'h-11 text-[15px]')} {...rest}>
        {children}
      </select>
    </div>
  );
}
